module.exports = __webpack_public_path__ + "static/5-miedos-1a583deca366c9869dc70c12f5199eb4.jpg";